/* eslint-disable */
export default
`<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html>
<head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <title></title>
    <style type="text/css">
        /* Client-specific Styles */
        #outlook a {
            padding: 0;
        }

        /* Force Outlook to provide a "view in browser" button. */
        body {
            width: 100% !important;
        }

        /* Force Hotmail to display emails at full width */
        body {
            -webkit-text-size-adjust: none;
            font-family: helvetica, "sans-serif";
        }

        /* Prevent Webkit platforms from changing default text sizes. */

        /* Reset Styles */

        body {
            margin: 0;
            padding: 0;
        }

        img {
            border: 0;
            height: auto;
            line-height: 100%;
            outline: none;
            text-decoration: none;
        }

        table td {
            border-collapse: collapse;
        }
    </style>
</head>
<body leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" style="background-color: #bdc3c7">
<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#bdc3c7;margin:0;padding:0;font-family:'Helvetica Neue','Helvetica',helvetica,arial,verdana,sans-serif;font-weight:300">
    <tbody>
    <tr valign="middle">
        <td height="20">&nbsp;</td>
    </tr>
    <tr valign="top">
        <td>
            <table width="600" cellpadding="0" cellspacing="0" border="0" align="center" bgcolor="#FFFFFF" style="background-color:#ffffff">
                <tbody>
                <tr>
                    <td style="padding: 10px 30px 30px 30px">
                        <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tbody>
                            <tr valign="top">
                                <td width="50%" align="left" style="font-weight: bold;font-size: 0.70em;color: #94A4A5;padding: 15px 0 6px 0">
                                    <p style="text-transform: uppercase; color: #34495E; font-size: 12px; margin: 0 0 10px 0">{{ subscription.initialInvoice.organization.name }}</p>
                                    {% if subscription.initialInvoice.organization.address %}
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ subscription.initialInvoice.organization.address }}</p>
                                    {% endif %}
                                    {% if subscription.initialInvoice.organization.address2 %}
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ subscription.initialInvoice.organization.address2 }}</p>
                                    {% endif %}
                                    {% if subscription.initialInvoice.organization.city %}
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ subscription.initialInvoice.organization.city }}</p>
                                    {% endif %}
                                    {% if subscription.initialInvoice.organization.country %}
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ subscription.initialInvoice.organization.country }}</p>
                                    {% endif %}
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ subscription.website.url }}</p>
                                </td>
                                <td width="50%" colspan="3" align="right" style="font-weight: bold;font-size: 0.70em;color: #94A4A5;padding: 15px 0 6px 0">
                                    <p style="text-transform: uppercase; color: #34495E; font-size: 12px; margin: 0 0 10px 0">billed to</p>
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ subscription.customer.firstName }} {{ subscription.customer.lastName }}</p>
                                    {% if subscription.customer.primaryAddress %}
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ subscription.customer.primaryAddress.address }}</p>
                                    {% endif %}
                                    {% if subscription.customer.primaryAddress.address2 %}
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ subscription.customer.primaryAddress.address2 }}</p>
                                    {% endif %}
                                    {% if subscription.customer.primaryAddress.city %}
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ subscription.customer.primaryAddress.city }}</p>
                                    {% endif %}
                                    {% if subscription.customer.primaryAddress.country %}
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ subscription.customer.primaryAddress.country }}</p>
                                    {% endif %}
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">&nbsp;</p>
                                    <p style="color: #7F8C8D;font-weight: normal; font-size: 12px;margin: 0">{{ "now" | dateUTC: "%B %e, %Y, %I:%M %p" }} UTC</p>
                                </td>
                            </tr>
                            <tr valign="middle">
                                <td height="20">&nbsp;</td>
                                <td height="20">&nbsp;</td>
                            </tr>
                            <tr>
                                <td align="left" width="50%" style="font-weight: bold;font-size: 0.70em;text-transform: uppercase;color: #94A4A5;border-bottom: 2px solid #ECF0F0;padding: 15px 0 6px 0">Description</td>
                                <td align="right" width="10%" style="font-weight: bold;font-size: 0.70em;text-transform: uppercase;color: #94A4A5;border-bottom: 2px solid #ECF0F0;padding: 15px 0 6px 0">Quantity</td>
                                <td align="right" width="20%" style="font-weight: bold;font-size: 0.70em;text-transform: uppercase;color: #94A4A5;border-bottom: 2px solid #ECF0F0;padding: 15px 0 6px 0">Unit Price</td>
                                <td align="right" width="20%" style="font-weight: bold;font-size: 0.70em;text-transform: uppercase;color: #94A4A5;border-bottom: 2px solid #ECF0F0;padding: 15px 0 6px 0">Line Total</td>
                            </tr>
                            {% for invoiceItem in subscription.initialInvoice.items %}
                            <tr {% if forloop.first != true %}style="border-top: 1px dashed #BDCECF"{% endif %}>
                                <td align="left">
                                    <p style="font-size: 12px;color: #7F8C8D;font-weight: bold;">{{ invoiceItem.description }} {% if subscription.plan.trial %}(Trial){% endif %}</p>
                                </td>
                                <td align="right">
                                    <p style="font-size: 12px;color: #7F8C8D;font-weight: bold;">{{ invoiceItem.quantity }}</p>
                                </td>
                                <td align="right">
                                    <p style="font-size: 12px;color: #7F8C8D;font-weight: bold;">{{ invoiceItem.unitPrice | money }}</p>
                                </td>
                                <td align="right">
                                    <p style="font-size: 12px;color: #7F8C8D;font-weight: bold;">{{ invoiceItem.price | money }}</p>
                                </td>
                            </tr>
                            {% endfor %}
                            <tr>
                                <td style="border-top: 2px solid #95A5A6;"></td>
                                <td align="right" colspan="3" style="border-top: 2px solid #95A5A6;padding-right: 10px">
                                    <p style="font-size: 14px;color: #34495E;font-weight: bold;">Subtotal&nbsp;&nbsp;{{ subscription.initialInvoice.currency }} {{ subscription.initialInvoice.subtotalAmount | money }}</p>
                                </td>
                            </tr>
                            {% if subscription.initialInvoice.discountAmount %}
                            <tr>
                                <td style="border-top: 2px solid #95A5A6;"></td>
                                <td align="right" colspan="3" style="border-top: 2px solid #95A5A6;padding-right: 10px">
                                    <p style="font-size: 14px;color: #34495E;font-weight: bold;">Discounts&nbsp;&nbsp;{{ subscription.initialInvoice.currency }} {{ subscription.initialInvoice.discountAmount | money }}</p>
                                </td>
                            </tr>
                            {% endif %}
                            {% for tax in subscription.initialInvoice.taxes %}
                            <tr>
                                <td style="border-top: 2px solid #95A5A6;"></td>
                                <td align="right" colspan="3" style="border-top: 2px solid #95A5A6;padding-right: 10px">
                                    <p style="font-size: 14px;color: #34495E;font-weight: bold;">{{ tax.description }}&nbsp;&nbsp;{{ subscription.initialInvoice.currency }} {{ tax.amount | money }}</p>
                                </td>
                            </tr>
                            {% endfor %}
                            <tr>
                                <td style="border-top: 2px solid #95A5A6;background: #ECF0F0;"></td>
                                <td align="right" colspan="3" style="border-top: 2px solid #95A5A6;background: #ECF0F0;padding-right: 10px">
                                    <p style="font-size: 14px;color: #34495E;font-weight: bold;">TOTAL&nbsp;&nbsp;{{ subscription.initialInvoice.currency }} {{ subscription.initialInvoice.amount | money }}</p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
        </td>
    </tr>
    <tr>
        <td>
            &nbsp;
        </td>
    </tr>
    </tbody>
</table>
</body>
</html>`
